import { useState } from 'react';
import Script from 'next/script';

type UseGoogleRecaptcha = {
  loadRecaptchaScript: () => JSX.Element;
  getRecaptchaToken: () => Promise<string>;
};

export const useGoogleRecaptcha = (): UseGoogleRecaptcha => {
  const publicKey = process.env.NEXT_PUBLIC_RECAPTCHA_KEY;
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  const loadRecaptchaScript = () => {
    if (!publicKey) {
      return <></>;
    }
    return (
      <Script
        id="google-recaptcha"
        src={`https://www.google.com/recaptcha/api.js?render=${publicKey}`}
        onLoad={() => {
          setIsScriptLoaded(true);
        }}
        strategy="afterInteractive"
      />
    );
  };

  const getRecaptchaToken = () => {
    if (!publicKey) {
      throw Error('Error: Public key not found for recaptcha');
    }

    if (!isScriptLoaded) {
      throw Error('Error: Recaptcha script failed to load');
    }

    return grecaptcha.execute(publicKey, {
      action: 'submit',
    });
  };

  return {
    loadRecaptchaScript,
    getRecaptchaToken,
  };
};
